import React, { useEffect } from "react";

function Test() {
  useEffect(() => {}, []);

  return (
    <>
      <div>Test</div>
    </>
  );
}
export default Test;
